export function isCommunity() {
    return true; // window.location.pathname.includes('/chat');
}
